import { render } from "./MalaUsers.vue?vue&type=template&id=31e28202&scoped=true"
import script from "./MalaUsers.vue?vue&type=script&lang=js"
export * from "./MalaUsers.vue?vue&type=script&lang=js"

import "./MalaUsers.vue?vue&type=style&index=0&id=31e28202&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e28202"]])

export default __exports__